/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactCheckList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 21c0-1.727.487-3.394 1.66-4.684 1.176-1.294 2.939-2.091 5.26-2.275l.16 1.994c-1.947.154-3.185.796-3.941 1.627C4.379 18.498 4 19.642 4 21v1H2zM5 7a5 5 0 0 1 10 0h-2a3 3 0 1 0-3.751 2.905l-.498 1.938A5.002 5.002 0 0 1 5 7z" />
        <path d="M22 9v13H11V9zm-9 11h7v-9h-7z" />
        <path d="M19.207 14.707 16 17.914l-2.207-2.207 1.414-1.414.793.793 1.793-1.793z" />
      </g>
    </g>
  </Icon>
);
export { SvgContactCheckList as ContactCheckList };
